import type { DriveStep } from "driver.js";

export const DASHBOARD_TOUR_STEPS: DriveStep[] = [
  {
    element: "[data-tour='sidebar']",
    popover: {
      title: "Menu Principal",
      description:
        "Navegue entre Dashboard, Templos, Mentor e Perfil. Tudo que voce precisa esta aqui.",
      side: "right",
      align: "start",
    },
  },
  {
    element: "[data-tour='epic-goal']",
    popover: {
      title: "Meta Epica",
      description:
        "Acompanhe seu progresso geral na jornada. A barra mostra o quanto voce ja avancou.",
      side: "bottom",
      align: "center",
    },
  },
  {
    element: "[data-tour='temples']",
    popover: {
      title: "Seus Templos de Poder",
      description:
        "Os 7 templos representam cada etapa da sua jornada. Comece pelo primeiro desbloqueado!",
      side: "top",
      align: "center",
    },
  },
  {
    element: "[data-tour='right-panel']",
    popover: {
      title: "Seu Progresso",
      description:
        "Veja seu streak, conquistas e acoes rapidas. Mantenha a consistencia!",
      side: "left",
      align: "start",
    },
  },
  {
    element: "[data-tour='help-fab']",
    popover: {
      title: "Precisa de Ajuda?",
      description:
        "Clique aqui sempre que tiver duvida. Acesse guias, tutoriais e perguntas frequentes.",
      side: "left",
      align: "end",
    },
  },
];
